module.exports = __webpack_public_path__ + "static/media/caretDown.ebe1c3a6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/caretDown.svg
// module id = 757
// module chunks = 0